import { RestRequest, } from '@Utils';
import { IPreviewVoiceAsterisk, ISharedVoiceAsterisk, } from 'atlas-shared/dist';

export * from './abstract/voice_asterisk.api.abstract';

export const resyncVoiceAsterisk = (id: IPreviewVoiceAsterisk['id']) => {
  return RestRequest.put<any, ISharedVoiceAsterisk>(`voice_asterisk/${id}/resync`, {}, { socket_id: global.socketId, });
};
